import type * as lazyIndex from "./lazyIndex";
import { LazyModule, createLazyComponent, type LazyComponent } from "owa-bundling";
import type { MeControlProps } from "./components/MeControl";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "OwaPreactMeControl" */ "./lazyIndex"), { name: "OwaPreactMeControl" });

export const LazyMeControl: LazyComponent<MeControlProps, unknown, void> = createLazyComponent(lazyModule, m => m.MeControl);
